module.exports = __webpack_public_path__ + "220afa3cc3560391765dc3bd8572f196.png";